<script lang="ts">
    import { getSeiten } from "../../api"
    import { apiBaseURL } from "../../config"
    import { i18n, location, sprache } from "../../store"
    import { getBreadcrumb } from "../Breadcrumb.svelte"
    import LadeAnimation from "../LadeAnimation.svelte"

    let treffer: {
        breadcrumb: string
        seite: Seite
        url: string
        blank?: boolean
    }[] = []

    let lade = true

    let suchwort
    $: {
        const qArr = new URLSearchParams($location.search.replace(/^\?/, ""))
        suchwort = qArr?.get("q")
    }

    async function such(str: string) {
        lade = true
        const s = (((await getSeiten($sprache, str)) || []) as Seite[])
            .map((p) => {
                return {
                    breadcrumb: getBreadcrumb(p),
                    seite: p,
                    url: p.pdfdownload
                        ? apiBaseURL +
                          "/seiten/" +
                          p.id +
                          "/" +
                          p.pdfdownload?.src
                        : p.link
                        ? p.link
                        : "/" + p.pfad,
                    blank: !!(p.pdfdownload || p.link),
                }
            })
            .sort((a, b) => {
                return a.breadcrumb > b.breadcrumb ? 1 : -1
            })

        treffer = s
        lade = false
    }

    $: such(suchwort)
</script>

<div class="collection">
    {#if lade}
        <LadeAnimation />
    {:else if treffer?.length}
        <div style="width: 100%">
            <p>
                {$i18n("Folgende Ergebnisse wurden für Ihr Suchwort gefunden")} (<strong
                    >{suchwort}</strong
                >) :<br /><br />
            </p>
        </div>
        <ul class="ergebnisliste">
            {#each treffer as t}
                <li>
                    <a href="{t.url}" target="{t.blank ? '_blank' : null}"
                        >{t.breadcrumb}</a
                    >
                </li>
            {/each}
        </ul>
    {:else}{$i18n("keine Treffer für")} &nbsp;<b>{suchwort}</b>{/if}
</div>

<style lang="less">
    @import "../../css/base.less";

    .ergebnisliste {
        list-style-type: none;
        margin: 0px;
        padding: 0px;
        li {
            margin: 0px;
            padding: 8px 0px;
            border-bottom: dotted 1px #999;
            a {
                color: @textcolor;
                &:hover {
                    color: @maincolor;
                }
            }

            &::before {
                content: "";
            }
        }
    }
</style>
